// const domain = "https://f3ad9fyuu0.execute-api.eu-central-1.amazonaws.com";
// const api_version = "development";
const domain = "https://api.digifarm.io";
const api_version = "v1";

export { domain };
export { api_version };
